import { type RouteRecordRaw } from 'vue-router'

export const appStoreRouter: RouteRecordRaw[] = [
  {
    children: [
      {
        component: async () => import('../views/AppStoreOverviewView.vue'),
        meta: {
          roles: ['pb:super'],
          title: 'apps.overview',
        },
        name: 'brand.apps.overview',
        path: 'overview',
      },
      {
        component: async () => import('../views/AppStoreReviewsView.vue'),
        meta: {
          roles: ['pb:super'],
          title: 'apps.reviews',
        },
        name: 'brand.apps.reviews',
        path: 'reviews',
      },
      {
        component: async () => import('../views/AppStoreComplianceView.vue'),
        meta: {
          roles: ['pb:super'],
          title: 'apps.compliance',
        },
        name: 'brand.apps.compliance',
        path: 'compliance',
      },
      {
        component: async () =>
          import('../views/AppStoreCustomersEmbeddedView.vue'),
        meta: {
          authZ: ({ user }) => user.can('read', 'customer'),
          permissions: [{ operation: 'read', resource: 'customer' }],
          scopes: ['customers:read'],
          title: 'apps.customers',
        },
        name: 'brand.apps.customers',
        path: 'customers',
      },
      {
        component: async () => import('../views/AppStoreEmailRelayView.vue'),
        meta: {
          roles: ['pb:super'],
          title: 'apps.email-relay',
        },
        name: 'brand.apps.email-relay',
        path: 'email-relay',
      },
    ],
    component: {
      name: 'AppStoreRouterView',
      template: '<router-view></router-view>',
    },
    name: 'brand.apps',
    path: 'apps',
    redirect: { name: 'brand.apps.overview' },
  },
]
